require('./release/angular-recaptcha.js');
module.exports = 'vcRecaptcha';



//////////////////
// WEBPACK FOOTER
// ../~/angular-recaptcha/index.js
// module id = 332
// module chunks = 0